import { useState, useEffect } from "react";
import apiBasic from "../services/apiBasic";
/**
 * @return {object} websocket data object
 * @return {function} 帶入參數
    url: string,
    apiName: string,
    params: string,
 * @return {function}  
    決定WebSocket開啟或關閉 true & false
  *@example
  *
  * ```js
*   changeOpenWorkSocketParams({
      url: "localhost9000",
      apiName: "openSocket",
      params: `UUID=${singleWpcRef.current.thisWpc.UUID}`,
    });
    setOpenWorkSocket(false);
  * ```
  * 
 */

const useWebSocket = () => {
  // 紀錄重新連線次數
  let [reconnect, setReconnect] = useState(0);
  //判斷是否有新 params 重新連線 webSocket
  let [isUpdateParams, setIsUpdateParams] = useState(false);

  let [ws, setWS] = useState();
  let [data, setData] = useState({ status: false, data: {}, msg: "" });
  let [isOpen, setIsOpen] = useState(false);
  let [apiParams, setApiParams] = useState({
    url: "",
    apiName: "",
    params: "",
  });

  let createWebSocket = () => {
    const conn = new WebSocket(
      `${apiBasic.conn === "http" ? "ws" : "wss"}://${apiParams.url}/api/${
        apiParams.apiName
      }?${apiParams.params}`
    );
    return conn;
  };

  let changeParams = ({ url, apiName, params }) => {
    setIsUpdateParams(true);
    setApiParams({
      url: url,
      apiName: apiName,
      params: params,
    });
  };

  useEffect(() => {
    if (ws && isUpdateParams) {
      const webSocketPath = createWebSocket();
      setWS(webSocketPath);
      setReconnect(0);
      setIsUpdateParams(false);
    }
  }, [apiParams]);

  useEffect(() => {
    if (!isOpen) {
      ws && ws.close();
      return;
    }
    if (apiParams.url === "" || apiParams.apiName === "") {
      setData({ status: false, data: "url or apiName is empty" });
      return;
    }
    const webSocketPath = createWebSocket();
    setWS(webSocketPath);
  }, [isOpen]);

  let isOpenSwitch = (val) => {
    val ? setIsOpen(true) : setIsOpen(false);
  };

  useEffect(() => {
    let resCodeStatus = (res) => {
      switch (res.status) {
        case 200:
          const data = res.data;
          setData({ status: true, data: data, msg: "資料獲取成功" });
          break;
        case 403:
          setData({ status: false, data: {}, msg: "403憑證過期返回登入頁面" });
          break;
        case 404:
          setData({
            status: false,
            data: {},
            msg: "404查無資料，請確認資料是否正確",
          });
          break;
        default:
          setData({
            status: false,
            data: {},
            msg: "502連線意外中斷，請嘗試重新連線",
          });
          break;
      }
    };
    try {
      if (ws) {
        ws.onopen = () => {
          console.log(
            `webSocket連線開啟 ${apiBasic.conn === "http" ? "ws" : "wss"}://${
              apiParams.url
            }/api/${apiParams.apiName}`
          );
        };
        ws.onmessage = (event) => {
          let res = JSON.parse(event.data);
          resCodeStatus(res);
        };
        ws.onclose = () => {
          setData({ status: false, data: {}, msg: "webSocket已關閉" });
          // setReconnect(reconnect + 1);
          console.log(
            `webSocket連線關閉 ${apiBasic.conn === "http" ? "ws" : "wss"}://${
              apiParams.url
            }/api/${apiParams.apiName}`
          );
        };
      } else {
        // console.log("in else ==> ", ws);
      }
    } catch (e) {
      setData({ status: false, data: {}, msg: "webSocke意外關閉連線" });
      setReconnect(reconnect + 1);
    }
    return () => {
      if (ws) {
        ws.close();
      }
    };
  }, [ws]);

  useEffect(() => {
    //斷線重連3次
    if (reconnect < 3 && isOpen === true && data.status === false) {
      console.log(
        `webSocket嘗試重新連線${reconnect} ${
          apiBasic.conn === "http" ? "ws" : "wss"
        }://${apiParams.url}/api/${apiParams.apiName}`
      );
      const webSocketPath = createWebSocket();
      setWS(webSocketPath);
      setReconnect(0);
    }
  }, [reconnect]);

  return [data, changeParams, isOpenSwitch];
};

export default useWebSocket;
